import type { ReactNode } from "react";

/** Title + subtitle at the top of every auth screen: a 28px regular-weight
 *  title (pages bold their key word, e.g. "Welcome To <b>MedSyncIQ</b>") over a
 *  14px gray subtitle. */
export function AuthHeading({
  title,
  subtitle,
  className,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  className?: string;
}) {
  return (
    <div className={className}>
      <h2 className="!mb-0 text-[28px] !font-normal leading-tight text-[#0A2947]">{title}</h2>
      {subtitle && <p className="!mt-2 !mb-0 text-sm text-[#9CA3AF]">{subtitle}</p>}
    </div>
  );
}
